import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/app/[locale]/(public)/news/CookieSetter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/app/[locale]/(public)/news/Item.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/data-dashboard/app/[locale]/(public)/news/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/app/[locale]/(public)/news/SignInButtons.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/data-dashboard/assets/images/bg-logo-pattern.png");
;
import(/* webpackMode: "eager" */ "/app/apps/data-dashboard/assets/images/mercedes-benz-data-dashboard-logo-wortmarke.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/components/Button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/components/InlineLanguageSwitch/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.3.4_next@15.5.24_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@types+node@20_32b6ad35a3489715c452b65cc7701bad/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.3.4_next@15.5.24_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@types+node@20_32b6ad35a3489715c452b65cc7701bad/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.24_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@types+node@20.12.5_react-dom@19.1.3_react@19.1.3__react@19.1.3/node_modules/next/dist/client/image-component.js");
